module.exports = __webpack_public_path__ + "resources/img/img_i_onenet_m_jp.aa8de8185b795bc9dbad66b220676c53.png";